import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Breadcrumb from "../components/Breadcrumb";

import ProjectService from "../services/ProjectService";
import pettyCashService from "../services/pettyCashService";
import StorageService from "../services/StorageService";
import utility from "../utils/utility";
import { configSettings } from "../config/configSettings";
import MessageDialog from "../components/MessageDialog";
import ReactPaginate from "react-paginate";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";

export default function PayPettyCash() {
    const [projects, setProjects] = useState([]);
    const [entries, setEntries] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState("");
    const [selectedEntry, setSelectedEntry] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [message, setMessage] = useState("");
    const [entryType, setEntryType] = useState("");
    const [msgType, setMsgType] = useState("error");
    const [editData, setEditData] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [receiptPreview, setReceiptPreview] = useState(null);
    const [receiptOld, setReceiptOld] = useState(null);
    // const [projectBalance, setProjectBalance] = useState(0);

    const [loading, setLoading] = useState(false);
    const [balance, setBalance] = useState(0);
    const [totalReceipt, setTotalReceipt] = useState(0);
    const [totalPayment, setTotalPayment] = useState(0);

    const { register, reset, watch } = useForm();
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [employees, setEmployees] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const itemsPerPage = 10;

    // const receiptAmount = useWatch({ control, name: "receiptAmount" }) || 0;
    // const paymentAmount = useWatch({ control, name: "paymentAmount" }) || 0;
    // const balanceAmount = Number(receiptAmount) - Number(paymentAmount);

    const emp = StorageService.loginData();
    const isSuperAdmin = Number(emp.roleId) === 1;
    const isDataAdmin = Number(emp.roleId) === 2 || Number(emp.roleId) === 1;
    const isOtherUser = Number(emp.roleId) !== 2;
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const isAdmin = Number(emp.roleId) === 1 || Number(emp.roleId) === 2;

    const [modalEmployeeId, setModalEmployeeId] = useState(null);
    const [employeeSearch, setEmployeeSearch] = useState("");

    const [showEmployeeDropdown, setShowEmployeeDropdown] = useState(false);

    const [rows, setRows] = useState([
        {
            employeeId: null,
            employeeSearch: "",
            showEmployeeDropdown: false,
            pettycashDate: new Date().toISOString().split("T")[0],
            details: "",
            modeOfPayment: "",
            receiptAmount: "",
            receiptPreview: null,
        }
    ]);

    const addRow = (index) => {
        const referenceRow = index !== undefined ? rows[index] : null;
        const newRow = {
            employeeId: null,
            employeeSearch: "",
            showEmployeeDropdown: false,
            pettycashDate: referenceRow ? referenceRow.pettycashDate : new Date().toISOString().split("T")[0],
            details: "",
            modeOfPayment: "",
            receiptAmount: "",
            receiptPreview: null,
        };

        if (index !== undefined && index !== null) {
            const updatedRows = [...rows];
            updatedRows.splice(index + 1, 0, newRow);
            setRows(updatedRows);
        } else {
            setRows([...rows, newRow]);
        }
    };

    const handleRowReceiptUpload = (index, e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setRows((prev) =>
                prev.map((row, rIdx) =>
                    rIdx === index ? { ...row, receiptPreview: reader.result } : row
                )
            );
        };
    };

    const showMessage = (msg, type = "error") => {
        setMessage(msg);
        setMsgType(type);
    };

    const { permission, checkView, can } = usePermission(
        ScreenData.Pay_Petty_Cash,
        showMessage
    );

    useEffect(() => {
        if (permission) {
            checkView();
        }
    }, [permission]);
    const loadEmployees = async () => {
        const comp = StorageService.activeCompany();
        // const res = await pettyCashService.getEmployeesByCompany(comp.companyId);
        const loginUser = StorageService.loginData();

        const res =
            await pettyCashService.getEmployeesByManager(
                comp.companyId,
                loginUser.employeeId,
                loginUser.roleId
            );
        console.log("EMPLOYEES RESPONSE", res);
        // setEmployees(res.data);
        setEmployees(res.data || []);
    };
    // const calculateProjectBalance = (list, fDate, tDate) => {
    //   if (!Array.isArray(list)) return 0;
    //   let totalReceipt = 0;
    //   let totalPayment = 0;
    //   list.forEach((e) => {
    //     if (fDate && tDate) {
    //       if (e.pettycashDate < fDate || e.pettycashDate > tDate) return;
    //     }
    //     totalReceipt += Number(e.receiptAmount || 0);
    //     totalPayment += Number(e.paymentAmount || 0);
    //   });
    //   return totalReceipt - totalPayment;
    // };


    // useEffect(() => {
    //     if (message) {
    //         const timer = setTimeout(() => setMessage(""), 2000);
    //         return () => clearTimeout(timer);
    //     }
    // }, [message]);


    // useEffect(() => {
    //     if (isDataAdmin) {
    //         loadEmployees();
    //     }
    // }, []);

    useEffect(() => {
        loadEmployees();
    }, []);

    //   const loadProjects = async () => {
    //     const emp = StorageService.loginData();
    //     const comp = StorageService.activeCompany();

    //     try {
    //       let projectsData = [];

    //       // SUPER ADMIN (roleId = 1) → ALL PROJECTS BY COMPANY
    //       if (Number(emp.roleId) === 1) {
    //         const res = await ProjectService.getActive(comp.companyId);

    //         projectsData = (res || []).map(p => ({
    //           projectId: p.id,
    //           projectName: p.projectName,
    //         }));
    //       }
    //       // ALL OTHER USERS → ONLY ASSIGNED PROJECTS
    //       else {
    //         const res = await ProjectService.getAssignedProjects(
    //           comp.companyId,
    //           emp.employeeId
    //         );
    //         projectsData = res?.data?.data || [];
    //       }

    //       setProjects(projectsData);
    //     } catch (err) {
    //       console.error("Error loading projects:", err);
    //       setProjects([]);
    //     }
    //   };

    const loadPettyCash = async ({
        filterEmployeeId = null,
        projectId = null,
    } = {}) => {
        try {
            setLoading(true);

            const comp = StorageService.activeCompany();
            const emp = StorageService.loginData();

            const payload = {
                roleId: Number(emp.roleId),
                employeeId: Number(filterEmployeeId),          // logged-in user
                companyId: comp.companyId,
                filterEmployeeId: filterEmployeeId ? Number(filterEmployeeId) : null,                    // selected from dropdown
                projectId: projectId ? Number(projectId) : null,
            };
            // alert(payload.companyId);
            const res = await pettyCashService.searchByDate({
                ...payload,
                page: currentPage,
                limit: itemsPerPage
            });
            setEntries(res?.data?.data || []);
            setPageCount(res?.data?.pagination.totalPages || 1);
        } catch (err) {
            console.error(err);
            setEntries([]);
        } finally {
            setLoading(false);
        }
    };

    //   const formatDate = (dateStr) => {
    //         if (!dateStr) return "-";
    //         const d = new Date(dateStr);
    //         if (isNaN(d)) return dateStr;

    //         const day = String(d.getDate()).padStart(2, "0");
    //         const month = String(d.getMonth() + 1).padStart(2, "0");
    //         const year = d.getFullYear();

    //         return `${day}-${month}-${year}`; // DD-MM-YYYY
    //     };
    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        return utility.formatDateDDMMMYYYY(dateStr);
    };

    const loadBalance = async (employeeId = null) => {
        const comp = StorageService.activeCompany();
        const targetEmployeeId = employeeId || emp.employeeId;

        const res = await pettyCashService.getEmployeeBalance(
            targetEmployeeId,
            comp.companyId
        );

        setTotalReceipt(res.totalReceipt || 0);
        setTotalPayment(res.totalPayment || 0);
        setBalance(res.balance || 0);
    };




    useEffect(() => {
        loadBalance();
    }, []);

    useEffect(() => {
        // loadProjects();
    }, []);

    useEffect(() => {
        const emp = StorageService.loginData();

        if (Number(emp.roleId) === 1 || Number(emp.roleId) === 2) {
            // Super Admin & Data Admin → auto load ALL
            loadPettyCash();
        } else {
            // Other users → self data
            setSelectedEmployeeId(emp.employeeId);
            loadPettyCash({ filterEmployeeId: emp.employeeId });
        }
    }, [currentPage]);


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(".position-relative")) {
                setShowEmployeeDropdown(false);
                setRows(prev => prev.map(r => ({ ...r, showEmployeeDropdown: false })));
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);


    const handleReceiptUpload = (e) => {
        utility.readFile(e, setReceiptPreview, "receiptURL");
    };

    const handleSelect = (id, entry) => {
        setSelectedId(id);
        setSelectedEntry(entry);
    };


    const openAddModal = (type) => {
        setEditData(null);
        setSelectedEntry(null);
        setEntryType(type);
        setModalEmployeeId(null);
        setEmployeeSearch("");

        if (type === "Receipt") {
            loadEmployees();
        }
        setReceiptPreview(null);
        setReceiptOld(null);

        // Initialize rows with a single clean row
        setRows([
            {
                employeeId: null,
                employeeSearch: "",
                showEmployeeDropdown: false,
                pettycashDate: new Date().toISOString().split("T")[0],
                details: "",
                modeOfPayment: "",
                receiptAmount: "",
                receiptPreview: null,
            }
        ]);

        reset({
            details: "",
            modeOfPayment: "",
            receiptAmount: "",
            paymentAmount: "",
            pettycashDate: new Date().toISOString().split("T")[0],
        });
        setShowModal(true);
    };

    const editEntry = () => {
        if (![1, 2].includes(Number(emp.roleId)) && !can("canModify")) {
            setMessage("You do not have permission to modify.");
            setMsgType("error");
            return;
        }
        if (!selectedId) {
            setMessage("Please select a record to modify.");
            setMsgType("error");
            return;
        }

        const row = entries.find((e) => e.id === selectedId);
        if (!row) {
            setMessage("Selected record not found.");
            setMsgType("error");
            return;
        }

        const today = new Date().toISOString().split("T")[0];

        if (
            !isAdmin &&
            row.pettycashDate !== today
        ) {
            setMessage("You can only modify today's entry.");
            setMsgType("danger");
            return;
        }

        const type = row.receiptAmount != null ? "Receipt" : "Payment";
        setEntryType(type);
        setEditData(row);

        if (row.employeeId) {
            setModalEmployeeId(row.employeeId);
            setEmployeeSearch("");
        }

        const rawReceipt = row.receiptURL || null;
        let filename = rawReceipt;
        let previewUrl = null;
        if (rawReceipt) {
            if (rawReceipt.startsWith("http://") || rawReceipt.startsWith("https://")) {
                previewUrl = rawReceipt;
                const parts = rawReceipt.split("/");
                filename = parts[parts.length - 1];
            } else {
                previewUrl = `${configSettings.mediaURL}/get/pettyCash/${rawReceipt}`;
            }
        }

        // Initialize rows with this single record's values
        const resetValues = {
            employeeId: row.employeeId,
            pettycashDate: row.pettycashDate || "",
            details: row.Details || "",
            modeOfPayment: row.modeOfPayment || "",
            receiptAmount: row.receiptAmount != null ? Number(row.receiptAmount) : "",
            receiptPreview: previewUrl,
            employeeSearch: "",
            showEmployeeDropdown: false,
        };
        setRows([resetValues]);

        reset({
            details: row.Details || "",
            modeOfPayment: row.modeOfPayment || "",
            pettycashDate: row.pettycashDate || "",
            receiptAmount: row.receiptAmount != null ? Number(row.receiptAmount) : "",
            paymentAmount: row.paymentAmount != null ? Number(row.paymentAmount) : "",
        });

        setReceiptOld(filename);
        setReceiptPreview(previewUrl);

        setShowModal(true);
    };


    //   useEffect(() => {
    //   setSelectedEmployeeId(emp.employeeId);
    // }, []);

    // useEffect(() => {
    //   if (selectedEmployeeId && selectedProjectId) {
    //     loadFilteredEntries(selectedEmployeeId, selectedProjectId);
    //   }
    // }, [selectedEmployeeId, selectedProjectId]);


    const handleSave = async () => {
        if (![1, 2].includes(Number(emp.roleId)) && !can("canAdd")) {
            setMessage("You do not have permission to add.");
            setMsgType("error");
            return;
        }

        const dateObj = new Date();
        const todayStr = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;

        // Check for duplicate employee selections
        const employeeIds = rows.map(r => r.employeeId).filter(id => id !== null && id !== undefined);
        const uniqueEmployeeIds = new Set(employeeIds);
        if (employeeIds.length !== uniqueEmployeeIds.size) {
            setMessage("Duplicate employee entries are not allowed.");
            setMsgType("error");
            return;
        }

        // Validate each row
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            
            if (!row.employeeId) {
                setMessage(`Please select employee for row ${i + 1}`);
                setMsgType("error");
                return;
            }

            const selectedDateStr = row.pettycashDate;
            if (!selectedDateStr) {
                setMessage(`Please select date for row ${i + 1}`);
                setMsgType("error");
                return;
            }

            if (selectedDateStr > todayStr) {
                setMessage(`Future dates are not allowed (row ${i + 1})`);
                setMsgType("error");
                return;
            }

            if (!isAdmin && selectedDateStr !== todayStr) {
                setMessage(`Normal users can only assign today's date (row ${i + 1})`);
                setMsgType("error");
                return;
            }

            if (!row.details || row.details.trim() === "") {
                setMessage(`Details are required for row ${i + 1}`);
                setMsgType("error");
                return;
            }

            if (!row.modeOfPayment) {
                setMessage(`Please select payment mode for row ${i + 1}`);
                setMsgType("error");
                return;
            }

            if (Number(row.receiptAmount) <= 0 || isNaN(Number(row.receiptAmount))) {
                setMessage(`Receipt amount must be greater than zero for row ${i + 1}`);
                setMsgType("error");
                return;
            }

            // Check employee date range against DOJ and DOR
            const selectedEmp = employees.find(e => Number(e.id) === Number(row.employeeId));
            if (selectedEmp) {
                const txDate = selectedDateStr.split("T")[0];
                if (selectedEmp.doj && txDate < selectedEmp.doj.split("T")[0]) {
                    setMessage(`Employee ${selectedEmp.firstName} ${selectedEmp.lastName} joined on ${utility.formatDateDDMMMYYYY(selectedEmp.doj)}. Date ${utility.formatDateDDMMMYYYY(txDate)} is not allowed (row ${i + 1}).`);
                    setMsgType("error");
                    return;
                }
                if (selectedEmp.dor && txDate > selectedEmp.dor.split("T")[0]) {
                    setMessage(`Employee ${selectedEmp.firstName} ${selectedEmp.lastName} relieved on ${utility.formatDateDDMMMYYYY(selectedEmp.dor)}. Date ${utility.formatDateDDMMMYYYY(txDate)} is not allowed (row ${i + 1}).`);
                    setMsgType("error");
                    return;
                }
            }
        }

        try {
            const comp = StorageService.activeCompany();

            // Prepare payload
            const payload = rows.map((row) => ({
                companyId: Number(comp.companyId),
                projectId: Number(selectedProjectId) || 0,
                entryType: "PAY_CASH",
                Details: row.details,
                modeOfPayment: row.modeOfPayment,
                pettycashDate: row.pettycashDate,
                status: "Active",
                receiptURL: row.receiptPreview,
                createdBy: emp.employeeId,
                employeeId: Number(row.employeeId),
                receiptAmount: Number(row.receiptAmount),
                paymentAmount: null,
            }));

            // Call bulk create API
            await pettyCashService.create(payload);

            setMessage("Saved successfully");
            setMsgType("success");

            await loadPettyCash({
                filterEmployeeId:
                    isAdmin ? selectedEmployeeId : emp.employeeId,
                projectId: selectedProjectId || null,
            });
            await loadBalance();
            setShowModal(false);
        } catch (err) {
            console.error(err);
            setMessage(err?.response?.data?.message || err?.message || "Error saving entry");
            setMsgType("error");
        }
    };

    const handleUpdate = async () => {
        if (![1, 2].includes(Number(emp.roleId)) && !can("canModify")) {
            setMessage("You do not have permission to update.");
            setMsgType("error");
            return;
        }

        const row = rows[0];
        if (!row) return;

        if (!row.employeeId) {
            setMessage("Please select employee");
            setMsgType("error");
            return;
        }

        const selectedDateStr = row.pettycashDate;
        const dateObj = new Date();
        const todayStr = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;

        if (selectedDateStr > todayStr) {
            setMessage("Future dates are not allowed");
            setMsgType("error");
            return;
        }

        if (!isAdmin && selectedDateStr !== todayStr) {
            setMessage("Normal users can only assign today's date");
            setMsgType("error");
            return;
        }

        if (!row.details || row.details.trim() === "") {
            setMessage("Details are required");
            setMsgType("error");
            return;
        }

        if (!row.modeOfPayment) {
            setMessage("Please select payment mode");
            setMsgType("error");
            return;
        }

        if (Number(row.receiptAmount) <= 0 || isNaN(Number(row.receiptAmount))) {
            setMessage("Receipt amount must be greater than zero");
            setMsgType("error");
            return;
        }

        // Check employee date range against DOJ and DOR
        const selectedEmp = employees.find(e => Number(e.id) === Number(row.employeeId));
        if (selectedEmp) {
            const txDate = selectedDateStr.split("T")[0];
            if (selectedEmp.doj && txDate < selectedEmp.doj.split("T")[0]) {
                setMessage(`Employee ${selectedEmp.firstName} ${selectedEmp.lastName} joined on ${utility.formatDateDDMMMYYYY(selectedEmp.doj)}. Date ${utility.formatDateDDMMMYYYY(txDate)} is not allowed.`);
                setMsgType("error");
                return;
            }
            if (selectedEmp.dor && txDate > selectedEmp.dor.split("T")[0]) {
                setMessage(`Employee ${selectedEmp.firstName} ${selectedEmp.lastName} relieved on ${utility.formatDateDDMMMYYYY(selectedEmp.dor)}. Date ${utility.formatDateDDMMMYYYY(txDate)} is not allowed.`);
                setMsgType("error");
                return;
            }
        }

        try {
            await pettyCashService.update(editData.id, {
                entryType: "PAY_CASH",
                Details: row.details,
                modeOfPayment: row.modeOfPayment,
                receiptAmount: Number(row.receiptAmount),
                paymentAmount: null,
                pettycashDate: row.pettycashDate,
                projectId: Number(selectedProjectId) || 0,
                receiptURL: (row.receiptPreview && row.receiptPreview.startsWith("data:"))
                  ? row.receiptPreview
                  : (row.receiptPreview ? receiptOld : null),
                receiptURLOld: (row.receiptPreview && row.receiptPreview.startsWith("data:"))
                  ? receiptOld
                  : (row.receiptPreview ? receiptOld : null),
                updatedBy: StorageService.loginData().employeeId,
                employeeId: Number(row.employeeId),
            });

            setMessage("Updated successfully");
            setMsgType("success");

            await loadPettyCash({
                filterEmployeeId:
                    isAdmin ? selectedEmployeeId : emp.employeeId,
                projectId: selectedProjectId || null,
            });

            await loadBalance();
            setShowModal(false);
            setSelectedEntry(null);
        } catch (err) {
            console.error(err);
            setMessage(err?.response?.data?.message || err?.message || "Error updating entry");
            setMsgType("error");
        }
    };

    const toggleStatus = async (entry) => {
        // if (!can("canModify")) {
        if (![1, 2].includes(Number(emp.roleId)) && !can("canModify")) {
            setMessage("You do not have permission to modify status.");
            setMsgType("error");
            return;
        }
        const newStatus = entry.status === "Active" ? "Inactive" : "Active";

        if (!window.confirm(`Change status to ${newStatus}?`)) return;

        try {
            await pettyCashService.updateStatus(entry.id);
            setMessage("Status updated successfully");
            setMsgType("success");
            await loadPettyCash({
                filterEmployeeId:
                    isAdmin ? selectedEmployeeId : emp.employeeId,
                projectId: selectedProjectId || null,
            });
        } catch {
            setMessage("Failed to update status");
            setMsgType("error");
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("You need to delete this record?")) return;

        try {
            await pettyCashService.delete(id);
            setMessage("Deleted successfully");
            setMsgType("success");
            await loadPettyCash({
                filterEmployeeId: isAdmin ? selectedEmployeeId : emp.employeeId,
                projectId: selectedProjectId || null,
            });
            await loadBalance();
        } catch (err) {
            console.error(err);
            setMessage("Error deleting entry");
            setMsgType("error");
        }
    };

    const filteredEmployees = employees.filter((emp) => {
        const fullName = `${emp.firstName} ${emp.lastName}`.toLowerCase();
        return fullName.includes(employeeSearch.toLowerCase());
    });

    return (
        <>
            <Breadcrumb pageTitle="Pay Petty Cash" secondTitle="Cash" />

            <MessageDialog
                message={message}
                type={msgType}
                setMessage={setMessage}
                setMsgType={setMsgType}
            />

            <div className="row">
                <div className="card p-3 mb-3 d-flex gap-3 align-items-end flex-row">

                    {/* EMPLOYEE – ONLY FOR RECEIPT (DATA / SUPER ADMIN) */}
                    <div>
                        <label className="form-label">Employees</label>

                        {isAdmin ? (
                            /* DATA ADMIN / SUPER ADMIN → DROPDOWN */
                            <select
                                className="form-select"
                                value={selectedEmployeeId}
                                onChange={(e) => {
                                    const empId = e.target.value || null;
                                    setSelectedEmployeeId(empId);

                                    loadPettyCash({
                                        filterEmployeeId: empId,
                                        projectId: selectedProjectId || null,
                                    });

                                    // ✅ UPDATE BALANCE
                                    loadBalance(empId);
                                }}
                            >
                                <option value="">Select Employee</option>

                                {employees.map((emp) => (
                                    <option key={emp.id} value={emp.id}>
                                        {emp.firstName} {emp.lastName}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            /* NORMAL USER → READ ONLY */
                            <input
                                type="text"
                                className="form-control"
                                value={`${emp.firstName} ${emp.lastName}`}
                                disabled
                            />
                        )}
                    </div>
                    <div style={{ width: "220px" }}>
                        <label className="form-label">Total Receipt</label>
                        <input
                            type="text"
                            className="form-control"
                            value={`₹ ${Number(totalReceipt || 0).toFixed(3)}`}
                            disabled
                        />
                    </div>

                    <div style={{ width: "220px" }}>
                        <label className="form-label">Total Payment</label>
                        <input
                            type="text"
                            className="form-control"
                            value={`₹ ${Number(totalPayment || 0).toFixed(3)}`}
                            disabled
                        />
                    </div>

                    <div style={{ width: "220px" }}>
                        <label className="form-label">Balance Amount</label>
                        <input
                            type="text"
                            className="form-control fw-bold"
                            value={`₹ ${Number(balance || 0).toFixed(3)}`}
                            disabled
                        />
                    </div>

                </div>

                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h5>Petty Cash</h5>
                        <div className="d-flex gap-2">
                            {can("canModify") && (
                                <button
                                    className="btn btn-warning"
                                    disabled={!selectedId}
                                    onClick={editEntry}
                                >
                                    <i className="ti ti-pencil me-1"></i> Modify
                                </button>
                            )}

                            {/* {isDataAdmin && can("canAdd") && ( */}
                            <button
                                className="btn btn-success"
                                // disabled={!selectedEmployeeId}
                                onClick={() => openAddModal("Receipt")}
                            >
                                Pay  Cash
                            </button>
                            {/* )} */}
                        </div>
                    </div>

                    <div className="card-body">
                        {/* {message && <div className={`alert alert-${msgType} py-2`}>{message}</div>} */}
                        <div
                            style={{
                                maxHeight: "65vh",
                                overflowY: "auto",
                                overflowX: "auto",
                                width: "100%",
                            }}
                        >
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Select</th>
                                        <th>Date</th>
                                        <th>Paid by</th>
                                        <th>Received by</th>
                                        <th>Details</th>
                                        <th>Mode Of Payment</th>
                                        <th>Amount</th>
                                        {/* <th>Payment Amount</th> */}
                                        <th>Receipt URL</th>
                                        {can("canReject") && <th>Action</th>}
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={can("canReject") ? 9 : 8} className="text-center py-4">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : entries.length ? (
                                        entries.map((e, idx) => (
                                            <tr
                                                key={e.id}
                                                className={selectedId === e.id ? "table-active" : ""}
                                                onClick={() => setSelectedEntry(e)}
                                            >
                                                <td className="text-center">
                                                    <input
                                                        type="radio"
                                                        checked={selectedId === e.id}
                                                        onChange={() => handleSelect(e.id, e)}
                                                        onClick={(evt) => evt.stopPropagation()}
                                                    />
                                                </td>
                                                <td>{formatDate(e.pettycashDate)}</td>
                                                <td>{e.createdByName}</td>
                                                <td>{e.employeeName}</td>
                                                <td>{e.Details}</td>
                                                <td>{e.modeOfPayment}</td>
                                                <td>{e.receiptAmount != null
                                                    ? Number(e.receiptAmount).toFixed(3)
                                                    : "-"}</td>
                                                {/* <td>{e.paymentAmount != null
                                                    ? Number(e.paymentAmount).toFixed(3)
                                                    : "-"}</td> */}
                                                <td>
                                                    {e.receiptURL ? (
                                                        <a
                                                            href={`${configSettings.mediaURL}/get/pettyCash/${e.receiptURL}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            View
                                                        </a>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>
                                                {can("canReject") && (
                                                    <td className="text-center">
                                                        {(() => {
                                                            const isDeletable = isAdmin || e.pettycashDate === `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}-${String(new Date().getDate()).padStart(2, "0")}`;
                                                            return (
                                                                <button
                                                                    className="btn btn-danger btn-sm"
                                                                    title={isDeletable ? "Delete" : "Only today's records can be deleted"}
                                                                    style={{
                                                                        opacity: isDeletable ? 1 : 0.4,
                                                                        cursor: isDeletable ? "pointer" : "not-allowed"
                                                                    }}
                                                                    disabled={!isDeletable}
                                                                    onClick={(evt) => {
                                                                        evt.stopPropagation();
                                                                        if (isDeletable) {
                                                                            handleDelete(e.id);
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="ti ti-trash"></i>
                                                                </button>
                                                            );
                                                        })()}
                                                    </td>
                                                )}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={can("canReject") ? 9 : 8} className="text-center text-muted">
                                                No records found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <ReactPaginate
                            forcePage={Math.max(0, currentPage - 1)}
                            onPageChange={(e) => setCurrentPage(e.selected + 1)}
                            pageCount={pageCount}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={2}
                            previousLabel="< Previous"
                            nextLabel="Next >"
                            containerClassName="pagination-container"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            nextClassName="page-item"
                            activeClassName="active"
                        />
                    </div>
                </div>

                {showModal && (
                    <div
                        style={{
                            position: "fixed",
                            inset: 0,
                            background: "rgba(0,0,0,0.5)",
                            zIndex: 1027,
                        }}
                    >
                        <div
                            style={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                width: "90%",
                                transform: "translate(-50%, -50%)",
                                background: "#fff",
                                padding: "20px",
                                borderRadius: "8px",
                            }}
                        >
                            <h5>{editData ? "Update Cash Entry" : "Add Cash Entry"}</h5>

                            {/* TABLE OF ROWS */}
                            {/* TABLE OF ROWS */}
                            <div 
                                className="w-100" 
                                style={
                                    rows.length > 5 
                                        ? { maxHeight: "350px", overflowY: "auto", overflowX: "auto" } 
                                        : { overflow: "visible" }
                                }
                            >
                                <table className="table table-bordered align-middle" style={{ overflow: "visible" }}>
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ width: "25%", minWidth: "180px" }}>Employee <span className="text-danger">*</span></th>
                                            <th style={{ width: "15%", minWidth: "130px" }}>Date <span className="text-danger">*</span></th>
                                            <th style={{ width: "25%", minWidth: "180px" }}>Details <span className="text-danger">*</span></th>
                                            <th style={{ width: "12%", minWidth: "110px" }}>Payment Mode <span className="text-danger">*</span></th>
                                            <th style={{ width: "10%", minWidth: "100px" }}>Amount <span className="text-danger">*</span></th>
                                            <th style={{ width: "18%", minWidth: "150px" }}>Upload Receipt</th>
                                            {!editData && <th style={{ width: "8%" }} className="text-center">Action</th>}
                                        </tr>
                                    </thead>
                                    <tbody style={{ overflow: "visible" }}>
                                        {rows.map((row, index) => {
                                            const selectedEmp = row.employeeId
                                                ? employees.find(e => Number(e.id) === Number(row.employeeId)) || (editData && Number(editData.employeeId) === Number(row.employeeId) ? { id: row.employeeId, firstName: editData.employeeName || "", lastName: "" } : null)
                                                : null;
                                            const selectedEmployeeName = selectedEmp
                                                ? `${selectedEmp.firstName || ''} ${selectedEmp.lastName || ''}`.trim()
                                                : "";
                                            
                                            const filteredEmployees = employees.filter((emp) => {
                                                const isAlreadySelected = rows.some((r, rIdx) => rIdx !== index && Number(r.employeeId) === Number(emp.id));
                                                if (isAlreadySelected) return false;

                                                // Filter out employees not active on the row's date
                                                if (row.pettycashDate) {
                                                    const txDate = row.pettycashDate.split("T")[0];
                                                    if (emp.doj && txDate < emp.doj.split("T")[0]) return false;
                                                    if (emp.dor && txDate > emp.dor.split("T")[0]) return false;
                                                }

                                                const fullName = `${emp.firstName} ${emp.lastName}`.toLowerCase();
                                                return fullName.includes((row.employeeSearch || "").toLowerCase());
                                            });

                                            return (
                                                <tr key={index} style={{ overflow: "visible" }}>
                                                    {/* EMPLOYEE SELECTOR */}
                                                    <td style={{ overflow: "visible" }}>
                                                        <div className="position-relative" style={{ overflow: "visible" }}>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                placeholder="Search employee..."
                                                                value={row.employeeId ? selectedEmployeeName : row.employeeSearch || ""}
                                                                onFocus={() => {
                                                                    setRows(prev => prev.map((r, i) => i === index ? { ...r, showEmployeeDropdown: true } : r));
                                                                }}
                                                                onChange={(e) => {
                                                                    const val = e.target.value;
                                                                    setRows(prev => prev.map((r, i) => i === index ? { 
                                                                        ...r, 
                                                                        employeeSearch: val, 
                                                                        showEmployeeDropdown: true,
                                                                        employeeId: null
                                                                    } : r));
                                                                }}
                                                            />
                                                            {row.showEmployeeDropdown && (
                                                                <div
                                                                    className="list-group shadow border rounded position-absolute w-100"
                                                                    style={{
                                                                        top: (rows.length > 3 && index >= rows.length - 2) ? "auto" : "100%",
                                                                        bottom: (rows.length > 3 && index >= rows.length - 2) ? "100%" : "auto",
                                                                        left: 0,
                                                                        maxHeight: "150px",
                                                                        overflowY: "auto",
                                                                        zIndex: 9999,
                                                                        marginTop: (rows.length > 3 && index >= rows.length - 2) ? "0" : "4px",
                                                                        marginBottom: (rows.length > 3 && index >= rows.length - 2) ? "4px" : "0",
                                                                        background: "#fff",
                                                                    }}
                                                                >
                                                                    {filteredEmployees.map((emp) => (
                                                                        <button
                                                                            key={emp.id}
                                                                            type="button"
                                                                            className="list-group-item list-group-item-action py-1 px-2 text-start"
                                                                            style={{ fontSize: "13px" }}
                                                                            onClick={() => {
                                                                                setRows(prev => prev.map((r, i) => i === index ? { 
                                                                                    ...r, 
                                                                                    employeeId: emp.id, 
                                                                                    employeeSearch: "", 
                                                                                    showEmployeeDropdown: false 
                                                                                } : r));
                                                                            }}
                                                                        >
                                                                            {emp.firstName} {emp.lastName}
                                                                        </button>
                                                                    ))}
                                                                    {filteredEmployees.length === 0 && (
                                                                        <div className="p-2 text-muted" style={{ fontSize: "13px" }}>No employees found</div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>

                                                    {/* DATE */}
                                                    <td>
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            value={row.pettycashDate}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                setRows(prev => prev.map((r, i) => {
                                                                    if (i !== index) return r;
                                                                    let updatedEmpId = r.employeeId;
                                                                    let updatedSearch = r.employeeSearch;
                                                                    if (r.employeeId && val) {
                                                                        const selected = employees.find(emp => Number(emp.id) === Number(r.employeeId));
                                                                        if (selected) {
                                                                            const txDate = val.split("T")[0];
                                                                            if ((selected.doj && txDate < selected.doj.split("T")[0]) ||
                                                                                (selected.dor && txDate > selected.dor.split("T")[0])) {
                                                                                updatedEmpId = null;
                                                                                updatedSearch = "";
                                                                            }
                                                                        }
                                                                    }
                                                                    return { ...r, pettycashDate: val, employeeId: updatedEmpId, employeeSearch: updatedSearch };
                                                                }));
                                                            }}
                                                            disabled={!isAdmin}
                                                            max={new Date().toLocaleDateString('en-CA')}
                                                        />
                                                    </td>

                                                    {/* DETAILS */}
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={row.details}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                setRows(prev => prev.map((r, i) => i === index ? { ...r, details: val } : r));
                                                            }}
                                                        />
                                                    </td>

                                                    {/* PAYMENT MODE */}
                                                    <td>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={row.modeOfPayment}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                setRows(prev => prev.map((r, i) => i === index ? { ...r, modeOfPayment: val } : r));
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="UPI">UPI</option>
                                                            <option value="Bank">Bank</option>
                                                            <option value="Cash">Cash</option>
                                                        </select>
                                                    </td>

                                                    {/* RECEIPT AMOUNT */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            step="0.001"
                                                            min="0"
                                                            className="form-control form-control-sm"
                                                            value={row.receiptAmount}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                setRows(prev => prev.map((r, i) => i === index ? { ...r, receiptAmount: val } : r));
                                                            }}
                                                            onBlur={(e) => {
                                                                if (e.target.value !== "") {
                                                                    const formattedVal = parseFloat(e.target.value).toFixed(3);
                                                                    setRows(prev => prev.map((r, i) => i === index ? { ...r, receiptAmount: formattedVal } : r));
                                                                }
                                                            }}
                                                        />
                                                    </td>

                                                    {/* UPLOAD RECEIPT */}
                                                    <td>
                                                        <div className="d-flex flex-column gap-1">
                                                            <input
                                                                type="file"
                                                                className="form-control form-control-sm"
                                                                accept="image/*,.pdf"
                                                                onChange={(e) => handleRowReceiptUpload(index, e)}
                                                            />
                                                            {row.receiptPreview && (
                                                                <div className="mt-1 d-flex align-items-center gap-2">
                                                                    {(row.receiptPreview.startsWith("data:image/") ||
                                                                     (row.receiptPreview.indexOf("data:") < 0 && 
                                                                      /\.(jpe?g|png|gif|webp|bmp)$/i.test(row.receiptPreview))) ? (
                                                                        <a
                                                                            href={row.receiptPreview}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            <img
                                                                                src={row.receiptPreview}
                                                                                alt="receipt"
                                                                                width="40"
                                                                                height="30"
                                                                                style={{ objectFit: "cover", borderRadius: "4px", cursor: "pointer" }}
                                                                            />
                                                                        </a>
                                                                    ) : (
                                                                        <a
                                                                            href={row.receiptPreview || (receiptOld ? `${configSettings.mediaURL}/get/pettyCash/${receiptOld}` : "#")}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="badge bg-info text-decoration-none"
                                                                            style={{ cursor: "pointer", fontSize: "10px" }}
                                                                        >
                                                                            View File
                                                                        </a>
                                                                    )}
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-danger py-0 px-1"
                                                                        style={{ fontSize: "10px" }}
                                                                        onClick={() => {
                                                                            setRows(prev => prev.map((r, i) => i === index ? { ...r, receiptPreview: null } : r));
                                                                        }}
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>

                                                    {/* DELETE ROW */}
                                                    {!editData && (
                                                        <td className="text-center">
                                                            <div className="d-flex align-items-center justify-content-center gap-1">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-sm d-inline-flex align-items-center justify-content-center"
                                                                    onClick={() => addRow(index)}
                                                                    style={{ width: "28px", height: "28px", padding: 0 }}
                                                                    title="Add Row"
                                                                >
                                                                    <i className="ti ti-plus" style={{ fontSize: "16px" }}></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center"
                                                                    disabled={rows.length === 1}
                                                                    onClick={() => {
                                                                        setRows(prev => prev.filter((_, i) => i !== index));
                                                                    }}
                                                                    style={{ width: "28px", height: "28px", padding: 0 }}
                                                                    title="Remove Row"
                                                                >
                                                                    <i className="ti ti-minus" style={{ fontSize: "16px" }}></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* ACTION BUTTONS */}
                            <div className="d-flex justify-content-end gap-2 mt-3">
                                {editData ? (
                                    <button className="btn btn-primary" onClick={handleUpdate}>
                                        <i className="ti ti-circle-check me-1"></i> Update
                                    </button>
                                ) : (
                                    <button className="btn btn-primary" onClick={handleSave}>
                                        <i className="ti ti-circle-check me-1"></i> Save
                                    </button>
                                )}

                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    <i className="ti ti-cancel me-1"></i> Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
